import { NgClass } from "@angular/common";
import { Component, inject, input, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { NavigationStart, Router } from "@angular/router";
import { NgbCollapse } from "@ng-bootstrap/ng-bootstrap";
import { AppService } from "src/app-legacy/core/services/app.service";

@Component({
	selector: "app-bottom-menu-sheet-item",
	imports: [MatIcon, NgClass, NgbCollapse],
	templateUrl: "./bottom-menu-sheet-item.component.html",
})
export class BottomMenuSheetItemComponent implements OnInit {
	private bottomSheet = inject(MatBottomSheet);
	private router = inject(Router);

	private appService = inject(AppService);
	isInternalView = this.appService.currentSchool.zfInternalViewSchool === "YES";

	icon = input.required<string>();
	hasSubMenu = input(false);

	isCollapsed = true;

	ngOnInit(): void {
		this.router.events.subscribe((e) => {
			if (e instanceof NavigationStart) {
				this.bottomSheet._openedBottomSheetRef?.dismiss();
			}
		});
	}

	open(): void {
		if (this.hasSubMenu()) {
			this.isCollapsed = !this.isCollapsed;
		}
	}
}
